<template>
  <div>
    <h1 class="text-3xl font-bold mb-6 text-center text-gray-800">Test Page Detail</h1>
    <div class="flex flex-col md:flex-row items-start justify-center">
      <!-- Page Content Section -->
      <div class="md:w-1/2 p-4 flex flex-col">
        <h2 class="text-xl font-semibold mb-4">Page Content</h2>
        <textarea
            v-model="content"
            class="w-full border border-gray-300 rounded-lg p-4 flex-grow"
            readonly
            :style="{ height: calculatedHeight + 'px', maxHeight: '80vh' }"
            ref="contentTextarea"
        ></textarea>
      </div>

      <!-- Page Image Section -->
      <div class="md:w-1/2 p-4 flex flex-col">
        <h2 class="text-xl font-semibold mb-4">Page Image</h2>
        <div class="flex-grow">
          <img :src="picture" alt="Test Page Image" class="w-full h-auto max-h-full rounded object-contain">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../services/axiosInstance'

export default {
  data () {
    return {
      content: '',
      picture: '',
      calculatedHeight: 0
    }
  },
  async created () {
    const pageId = this.$route.params.pageId
    const studentId = this.$route.params.studentId
    try {
      const response = await axios.get(`/students/${studentId}/pages/${pageId}`)
      this.content = response.data.content

      this.picture = `data:image/png;base64,${response.data.picture}`

      this.$nextTick(() => {
        this.adjustTextareaHeight()
      })
    } catch (error) {
      console.error('Error fetching page details:', error)
    }
  },
  methods: {
    adjustTextareaHeight () {
      const textarea = this.$refs.contentTextarea
      if (textarea) {
        textarea.style.height = 'auto' // Reset height to auto to calculate full height
        this.calculatedHeight = Math.min(textarea.scrollHeight, window.innerHeight * 0.8)
      }
    }
  },
  watch: {
    content () {
      this.adjustTextareaHeight() // Recalculate height when content changes
    }
  }
}
</script>

<style scoped>
textarea {
  resize: none; /* Disable manual resizing */
  overflow-y: auto;
}
.flex-grow {
  display: flex;
  flex-direction: column;
}
</style>
